import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, useSearchParams } from 'react-router-dom';
import './login.css'; // Make sure to create this CSS file

const Login = () => {
  const { isAuthenticated, login, loading } = useAuth();
  const [searchParams] = useSearchParams();
     
  const error = searchParams.get('error');
  const logout = searchParams.get('logout');

  useEffect(() => {
    console.log('Login component - Auth state:', { isAuthenticated, loading });
  }, [isAuthenticated, loading]);

  if (loading) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="loading">
            <div className="loading-spinner"></div>
            <p>Checking authentication...</p>
          </div>
        </div>
      </div>
    );
  }

  if (isAuthenticated && !loading) {
    console.log('Redirecting authenticated user to dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  const handleSignUp = () => {
    // Implement sign up functionality or redirect
    console.log('Sign up clicked');
    // You can add your sign-up logic here
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* ClusterMicro Logo */}
        <div className="logo-container">
          <svg width="280" height="60" viewBox="0 0 280 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="logo">
            <text x="10" y="42" fontFamily="Arial, sans-serif" fontSize="36" fontWeight="bold" fill="#DC2626">
              clustermicro
            </text>
          </svg>
        </div>
        
        <h2>Sign In</h2>
        
        {/* Error Message */}
        {error && (
          <div className="error-message">
            <p>Login failed: {error}</p>
          </div>
        )}
        
        {/* Success Message */}
        {logout && (
          <div className="success-message">
            <p>You have been logged out successfully.</p>
          </div>
        )}
        
        {/* Amazon Cognito Login Button */}
        <button
          onClick={login}
          className="cognito-button"
          disabled={loading}
        >
          {loading ? 'Signing In...' : 'Login with Amazon Cognito'}
        </button>
        
        {/* Sign Up Link */}
        <p className="signup-prompt">
          Don't have an account? <a href="#" onClick={handleSignUp}>Sign Up</a>
        </p>
      </div>
    </div>
  );
};

export default Login;